"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.dm.communicationType.wa': 'WA',
    'whatsapp.dm.communicationType.tele': 'TELE',
    'whatsapp.dm.loading': 'Cargando...',
    'whatsapp.dm.back': 'Volver',
    'whatsapp.dm.contactInfo': 'Info del contacto',
    'whatsapp.dm.contactName': 'Nombre',
    'whatsapp.dm.contactId': 'ID del contacto',
    'whatsapp.dm.messages': 'Mensajes',
    'whatsapp.dm.noMessages': 'No se encontraron mensajes para este rango de fechas.',
    'whatsapp.dm.dateFrom': 'Desde',
    'whatsapp.dm.dateTo': 'Hasta',
    'whatsapp.dm.summarize': 'Resumir',
    'whatsapp.dm.summarizeDone': 'Resumen de DM generado exitosamente.',
    'whatsapp.dm.summarizeFailed': 'No se pudo generar el resumen de DM.',
    'whatsapp.dm.botSender': 'Bot',
    'whatsapp.dm.media.attachment': 'Adjunto',
    'whatsapp.dm.summaries.title': 'Resúmenes',
    'whatsapp.dm.summaries.empty': 'Aún no hay resúmenes.',
    'whatsapp.dm.summaries.date': 'Fecha',
    'whatsapp.dm.summaries.excerpt': 'Extracto',
    'whatsapp.dm.summaries.modalTitle': 'Resumen de DM',
    'whatsapp.dm.stats.contacts': 'Contactos',
    'whatsapp.dm.stats.total': 'Total',
    'whatsapp.dm.syncMessages.button': 'Sincronizar mensajes',
    'whatsapp.dm.syncMessages.failed': 'No se pudieron sincronizar los mensajes.',
};
